const initialState = {
    expandedId: 0,
};
const card_shop = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_CARD_SHOP':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default card_shop;
